
import React from "react";
import { Container } from "reactstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Mousewheel, Keyboard, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/mousewheel";
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';
import client1 from '../../assets/img/client1.jpg'
import client2 from '../../assets/img/client2.jpg'
import coworker from '../../assets/img/coworker.png'
import stefanAlexandruVirna from '../../assets/img/Ștefan Alexandru Vîrnă.jpg'
import eleftheriaTsokataridou from '../../assets/img/Eleftheria-Tsokataridou.png'
import georgeCoblisan from '../../assets/img/George-Coblisan.jpg'

export default function Testimonials() {
  const [ref, inView] = useInView({
    triggerOnce: true,
  });

  const testimonialsData = [
    {
      id: 1,
      imgSrc: client1,
      text: "Working with Gulfam felt easy from day one. He quickly understood what we wanted, shared thoughtful design ideas, and turned them into a clean website that fits our brand. He was responsive throughout and solved small issues without delay. I would happily work with him again.",
      clientName: "Emiliana Di Muccio",
      role: "Client",
    },
    {
      id: 2,
      imgSrc: client2,
      text: "Gulfam is reliable, skilled, and very easy to communicate with. He kept us updated, explained decisions clearly, and handled every revision with patience. The final result looked polished and performed well. It genuinely felt like he cared about the project as much as we did.",
      clientName: "Ava",
      role: "Client",
    },
    {
      id: 3,
      imgSrc: coworker,
      text: "I have collaborated with Gulfam on multiple client projects, and he consistently delivers. He communicates clearly, takes ownership, and stays calm when deadlines are tight. What I appreciate most is his mindset: he focuses on practical solutions and quality, not just finishing tasks.",
      clientName: "Muhammad Zeshan",
      role: "Coworker",
    },
    {
      id: 4,
      imgSrc: stefanAlexandruVirna,
      text: "Gulfam translated our ideas into a polished website with excellent attention to detail. He stayed responsive, explained technical choices in simple terms, and made the whole process smooth from start to finish.",
      clientName: "Ștefan Alexandru Vîrnă",
      role: "Client",
    },
    {
      id: 5,
      imgSrc: eleftheriaTsokataridou,
      text: "What stood out most was the reliability. Timelines were respected, communication was clear, and revisions were handled quickly. The final result felt thoughtful, modern, and exactly aligned with our expectations.",
      clientName: "Eleftheria Tsokataridou",
      role: "Client",
    },
    {
      id: 6,
      imgSrc: georgeCoblisan,
      text: "Working with Gulfam was a great experience. He brings both creativity and problem-solving, and he genuinely cares about the quality of the final product. I would confidently recommend him for web projects.",
      clientName: "George Coblisan",
      role: "Client",
    },
   
  ];

  return (
    <div   className='bg-[#F9F9F9] rounded-t-3xl bottom-5 relative py-20  px-3 flex items-center justify-center flex-col w-full'>
    <h6 className='text-[26px] sm:text-[32px] md:text-[40px] font-bold'>TESTIMONIALS</h6>
    <div className='section-line'></div>
    <p className='text-[16px] md:text-[20px] w-[97%] sm:w-[90%] md:w-[65%] lg:w-[55%] xl:w-[47%] text-center text-[#555555]'>
      Explore what clients say about their successful experiences with <b>me</b>.
    </p>
    <Container fluid className="client w-full h-[324px] md:h-[420px] lg:h-[500px] xl:h-[570px] flex justify-center items-center ">
      
    <Swiper
     cssMode={true}
     navigation
     loop
     autoplay={{ delay: 10000, disableOnInteraction: false }}
     modules={[Navigation, Pagination, Mousewheel, Keyboard, Autoplay]}
     pagination={true}
     mousewheel={true}
     keyboard={true}
     className="client-Swiper"
          >
        {testimonialsData.map((testimonial) => (
          <SwiperSlide key={testimonial.id} className="swiperSlide">
          <div className="flex items-center justify-center py-3 lg:mt-5 lg:py-5">
            <img
              src={testimonial.imgSrc}
              alt=" "
              className="img-fluid rounded-full  h-[120px] w-[120px]"
            />
          </div>
          <div className="px-10 mb-3 d-flex align-items-center justify-content-center md:mb-5">
            <div>
              <p className="text-sm italic text-secondary">
              “{testimonial.text}” 
              </p>
              <h5 className="text-lg"               >{testimonial.role}</h5>
              <h6 className="text-lg text-site-text">{testimonial.clientName}</h6>
            </div>
          </div>
        </SwiperSlide>
        ))}
      </Swiper>
    </Container>

    {/* React UP COUNT */}
    <div ref={ref} className=" rounded-xl border-black sm:justify-evenly w-[90%] flex flex-col gap-y-5 justify-center sm:flex-row shadow-lg sm:items-center p-3 sm:w-[100%] md:w-[80%] lg:-[75%] xl:w-[65%] mt-5 " data-aos='fade-up' data-aos-offset='100' data-aos-delay='100'>
    <div className="pr-5 border-black sm:border-r">
        <h6 className="text-4xl font-bold sm:text-2xl md:text-3xl lg:text-5xl" >{inView && <CountUp start={0} end={31} duration={9} />}+</h6>
        <p className="text-[#555555] font-semibold">Successful Projects</p>
    </div>
    <div className="pr-5 border-black sm:border-r">
        <h6 className="text-4xl font-bold sm:text-2xl md:text-3xl lg:text-5xl"  >{inView && <CountUp start={0} end={9} duration={12} />}+</h6>
        <p className="text-[#555555] font-semibold">Satisfied Clients</p>
    </div>
    <div>
        <h6 className="text-4xl font-bold sm:text-2xl md:text-3xl lg:text-5xl" >
        {inView && <CountUp start={0} end={99} duration={8} />}%</h6>
        <p className="text-[#555555] font-semibold">Success Rate</p>
    </div>
    </div>
    </div>
  );
}
